import ColumnsHeaders from "PFApp/components/table/columns_headers";
import { TableColumn } from "PFApp/components/table/table_types";
import { SkillsFrameworksResponse } from "PFCore/services/admin/skills_frameworks/fetch_skills_frameworks";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./skills_frameworks_table.module.scss";

type SkillsFrameworksColumnsHeadersProps = {
  skillsFrameworks: SkillsFrameworksResponse;
  columns: TableColumn[];
};

export const SkillsFrameworksColumnsHeaders = ({
  skillsFrameworks,
  columns
}: SkillsFrameworksColumnsHeadersProps) => {
  const { t } = useTranslation("skillsFrameworks");
  const { meta } = skillsFrameworks;

  return (
    <ColumnsHeaders
      className={css.headers}
      columns={columns}
      actionsHeader={t("list.table.actions.label")}
      order={meta.order}
      onOrderChange={() => {}}
      classes={{ mediumColumn: css.mediumColumn }}
    />
  );
};
